import { cartFragment } from '../fragments/cartFields';

export const cartByIdQuery = /* GraphQL */ `
  ${cartFragment}
  query GetCartById($cartId: ID!) {
    cart(id: $cartId) {
      ...CartFields
      deliveryGroups(first: 1) {
        edges {
          node {
            deliveryOptions {
              handle
              title
              estimatedCost {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`;
